import styled from '@emotion/styled'
import { t } from 'i18next'
import { getBookCoverByClil } from '../../../../core/helpers/clil.helper'
import { ReactComponent as AddIcon } from '../../../../assets/icons/app/add.icon.svg'
import { BookInterface } from '../../../../core/interface/book.interface'
import { AnalyticsPermissionEnum } from '../../../../core/enums/analytics-permission.enum'
import { WM_REPORT_SIZE_MAX_BOOK_SELECTION } from '../../../../core/config/reports/report-details.config'
import { analyticsDetailV2StateSetBooksInputsMenuOpen } from '../../../../store/reducers/analytics-details/analytic-details-v2.reducer'
import { useAppDispatch } from '../../../../store/hooks'
import GlLoader from '../../../share/GlLoader'
import { LabelButtonStyle, TitleCloseStyle } from '../SearchBarComponentsStyle'

const ImageCloseStyle = styled.img`
  min-width: 16px;
  max-width: 16px;
  min-height: 16px;
  max-height: 16px;
  object-fit: cover;
  border-radius: 8px;
`

type Props = {
  booksInput: BookInterface[]
  isLoadingRemove: boolean
  isLoadingNewConstellationGetBookReco: boolean
  permission?: AnalyticsPermissionEnum
}

const PreviewBooksInput = ({
  booksInput,
  isLoadingRemove,
  isLoadingNewConstellationGetBookReco,
  permission,
}: Props) => {
  const dispatch = useAppDispatch()
  const handleOnClickAddBook = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    dispatch(analyticsDetailV2StateSetBooksInputsMenuOpen(true))
  }

  return (
    <div className="flex flex-col gap-2">
      {booksInput.map((bookInput: BookInterface) => (
        <div
          key={`book-input-miature-${bookInput.id_ean}`}
          className="flex flex-row items-center justify-start gap-2"
        >
          <ImageCloseStyle
            src={bookInput?.imgs || getBookCoverByClil(bookInput.clil1)}
            alt="cover book"
          />
          <TitleCloseStyle>{bookInput.title}</TitleCloseStyle>
        </div>
      ))}
      {(!isLoadingRemove &&
        !isLoadingNewConstellationGetBookReco &&
        permission === AnalyticsPermissionEnum.EDIT &&
        booksInput.length < WM_REPORT_SIZE_MAX_BOOK_SELECTION && (
          <div className="flex flex-row w-full">
            <LabelButtonStyle
              type="button"
              className="flex flex-row justify-start items-center gap-1"
              onClick={handleOnClickAddBook}
            >
              <AddIcon className="w-4 h-4" />
              <span>{t('webApp.search.books.addBooks')}</span>
            </LabelButtonStyle>
          </div>
        )) ||
        null}

      {(((isLoadingRemove && booksInput.length < 3) ||
        (isLoadingNewConstellationGetBookReco && booksInput.length < 3)) && (
        <div
          className="flex flex-row items-center justify-center"
          style={{
            width: '100&',
            height: 40,
          }}
        >
          <GlLoader width={30} height={30} />
        </div>
      )) ||
        null}
    </div>
  )
}

export default PreviewBooksInput
